export default {
  storageType: 'http',
  api_url: '',
};
